/** Parametri adrese stranice Korisnici dostavne firme. */
export const TEAM_QUERY = {
  kind: "k",
  status: "s",
  legacy: "ui",
};

/** ?ui=stari vraća staru stranicu (isti naziv kao u finansijama) */
export const LEGACY_UI_VALUE = "stari";
